import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { cn } from "app/lib/utils";

interface Props {
  onClick: () => void;
  icon: IconProp;
  size?: "small" | "medium" | "large";
  className?: string;
  ariaLabel?: string;
}

const SIZE_CLASSES: Record<NonNullable<Props["size"]>, string> = {
  small: "h-6 w-6 text-xs",
  medium: "h-8 w-8",
  large: "h-10 w-10",
};

export default function CircleIconButton({
  onClick,
  icon,
  size = "medium",
  className,
  ariaLabel,
}: Readonly<Props>) {
  return (
    <button
      onClick={onClick}
      className="no-style-button"
      aria-label={ariaLabel}
    >
      <div
        className={cn(
          "flex items-center justify-center rounded-full border border-neutral-white-100",
          "bg-sapphire-10 text-sapphire-100 transition-colors hover:bg-sapphire-20",
          SIZE_CLASSES[size],
          className
        )}
      >
        <FontAwesomeIcon icon={icon} />
      </div>
    </button>
  );
}
